var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.typeCaptcha === "yandex_smartcaptcha"
    ? _c(
        "YandexSmartCaptcha",
        {
          ref: "captcha",
          attrs: { sitekey: _vm.keyCaptcha },
          on: {
            verify: function($event) {
              return _vm.$emit("verify", $event)
            },
            expired: function($event) {
              return _vm.$emit("expired", $event)
            },
            render: function($event) {
              return _vm.$emit("render", $event)
            },
            "process-execute": function($event) {
              return _vm.$emit("process-execute", $event)
            }
          }
        },
        [_vm._t("default")],
        2
      )
    : _c(
        "GoogleCaptcha",
        {
          ref: "captcha",
          attrs: { sitekey: _vm.keyCaptcha },
          on: {
            verify: function($event) {
              return _vm.$emit("verify", $event)
            },
            expired: function($event) {
              return _vm.$emit("expired", $event)
            },
            render: function($event) {
              return _vm.$emit("render", $event)
            }
          }
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }